import {
  Campaign as CampaignIcon,
  Close as CloseIcon,
  NavigateBefore as NavigateBeforeIcon,
  NavigateNext as NavigateNextIcon
} from '@mui/icons-material';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';

// Manuel güncelleme notları - Buraya yeni notları ekleyin
const updateNotes = [
  {
    id: 1,
    date: '22.01.2026',
    title: '📢 Reklam Yönetimi & Kar Hesaplama',
    description: 'Yapay zeka ile pazaryerlerindeki reklamlarınızın otomatik yönetimi ve offline kar hesaplama programları için WhatsApp: +90 538 467 71 50',
    fullDescription: 'Yapay zeka ile pazaryerlerindeki reklamlarınızın otomatik yönetilmesi ve sadece sizin cihazınızda çalışan kar hesaplama yönetim programları için whatsapp hattımıza ulaşabilirsiniz. Detaylı bilgi ve demo için WhatsApp: +90 538 467 71 50'
  },
  {
    id: 2,
    date: '10.01.2026',
    title: '📦 Trendyol Sipariş Soruları Yönetimi',
    description: 'Artık Trendyoldaki SİPARİŞ sorularının da otomatik yönetilebilmesini sağlıyoruz, detaylı bilgi için satış temsilcinize ulaşabilirsiniz.',
    fullDescription: 'Trendyol daki sipariş sorularınız artık yapay zeka tarafından otomatik olarak yönetilebilir. Müşteri memnuniyetini artırın ve yanıt sürelerinizi kısaltın. Detaylı bilgi ve kurulum için satış temsilciniz ile iletişime geçebilirsiniz.'
  },
  {
    id: 3,
    date: '01.01.2026',
    title: '🚀 Premium AI Modeli',
    description: 'En üst düzey yapay zeka modeli eklendi. (Sadece çok karmaşık ve insanüstü bağlam sağlayan sorular ve internet araştırması gibi özel yetenekler gerektiren istisnai müşterilerimiz için tavsiye edilmektedir.)',
    fullDescription: 'Artık mevcut ücretin üzerine ekstra %120 fark ile en üst düzey yapay zekaya geçme imkanı tanıyoruz. Bu yalnızca çok karmaşık ve insanüstü bağlam isteyen sorular ve internet araştırması gibi özel yetenekler gerektiren istisnai müşterilerimiz için tavsiye edilmektedir. Standart AI modelimiz çoğu kullanım senaryosu için %95 oranında yeterlidir.'
  },
  {
    id: 4,
    date: '22.11.2025',
    title: '🎯 Thinking Özelliği',
    description: 'Thinking özelliği ile verilen cevaplar daha isabetli ve detaylı hale getirildi!',
    fullDescription: 'Yapay zeka artık soruları daha derin analiz ederek, daha kapsamlı ve isabetli cevaplar üretebiliyor. Bu özellik sayesinde müşteri memnuniyeti ve cevap kalitesi önemli ölçüde artmıştır.'
  },
  {
    id: 5,
    date: '20.11.2025',
    title: '⚡ Performans İyileştirmeleri',
    description: 'Dashboard yükleme süreleri %40 oranında hızlandırıldı!',
    fullDescription: 'Sistem altyapısında yapılan optimizasyonlar sayesinde sayfa yükleme süreleri önemli ölçüde azaltıldı. Özellikle büyük veri setlerinde performans artışı göze çarpmaktadır.'
  },
  {
    id: 6,
    date: '18.11.2025',
    title: '🎨 Yeni Dashboard Tasarımı',
    description: 'Dashboard arayüzü daha modern ve kullanıcı dostu hale getirildi!',
    fullDescription: 'Kullanıcı deneyimini iyileştirmek amacıyla dashboard tasarımı yenilendi. Daha sezgisel menüler, renkli kartlar ve gelişmiş grafiklerle verilerinizi daha kolay takip edebilirsiniz.'
  },
  {
    id: 7,
    date: '15.11.2025',
    title: '📊 Gelişmiş Raporlama',
    description: 'Yeni raporlama özellikleri ile detaylı analizler yapabilirsiniz!',
    fullDescription: 'Mağaza bazlı, ürün bazlı ve zaman bazlı detaylı raporlar oluşturabilir, Excel formatında indirebilirsiniz. Performans metriklerinizi daha iyi takip edin.'
  },
  {
    id: 8,
    date: '10.11.2025',
    title: '🔔 Bildirim Sistemi',
    description: 'Önemli olaylar için anlık bildirim sistemi devreye alındı!',
    fullDescription: 'Yeni sorular, onay bekleyen cevaplar ve sistem güncellemeleri için anlık bildirim alabilirsiniz. Hiçbir önemli olayı kaçırmayın!'
  }
];

function UpdateNotesBanner({ inline = false }) {
  const [currentNoteIndex, setCurrentNoteIndex] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Otomatik geçiş - 5 saniyede bir
  useEffect(() => {
    if (isPaused || dialogOpen) return;

    const interval = setInterval(() => {
      setCurrentNoteIndex((prevIndex) =>
        prevIndex === updateNotes.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [isPaused, dialogOpen]);

  const handleNext = () => {
    setCurrentNoteIndex((prevIndex) =>
      prevIndex === updateNotes.length - 1 ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentNoteIndex((prevIndex) =>
      prevIndex === 0 ? updateNotes.length - 1 : prevIndex - 1
    );
  };

  const currentNote = updateNotes[currentNoteIndex];

  // Inline mode - AppBar içinde gösterim
  if (inline) {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            height: '100%',
            minWidth: 0,
            overflow: 'hidden',
            transition: 'opacity 0.2s ease',
            '&:hover': {
              opacity: 0.85,
            },
          }}
          onClick={() => setDialogOpen(true)}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <CampaignIcon sx={{ fontSize: 18, mr: 1, flexShrink: 0 }} />
          <Box sx={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
            <motion.div
              key={currentNote.id}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: '0.813rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  color: 'inherit'
                }}
              >
                <strong>{currentNote.date}</strong> - {currentNote.description}
              </Typography>
            </motion.div>
          </Box>
          {!isMobile && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 1, flexShrink: 0 }}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handlePrev();
                }}
                sx={{ color: 'inherit', p: 0.5, '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
              >
                <NavigateBeforeIcon fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ fontSize: '0.7rem', mx: 0.5 }}>
                {currentNoteIndex + 1}/{updateNotes.length}
              </Typography>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleNext();
                }}
                sx={{ color: 'inherit', p: 0.5, '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
              >
                <NavigateNextIcon fontSize="small" />
              </IconButton>
            </Box>
          )}
        </Box>

        {/* Dialog */}
        <Dialog
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          maxWidth="md"
          fullWidth
          fullScreen={isMobile}
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              bgcolor: 'primary.main',
              color: 'white'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CampaignIcon />
              <Typography variant="h6">Tüm Güncelleme Notları</Typography>
            </Box>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setDialogOpen(false)}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            {updateNotes.map((note, index) => (
              <React.Fragment key={note.id}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    mb: 2,
                    border: currentNoteIndex === index ? '2px solid' : 'none',
                    borderColor: 'primary.main',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: 4,
                      transform: 'translateY(-2px)'
                    }
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                    <Box
                      sx={{
                        minWidth: 60,
                        textAlign: 'center',
                        pt: 0.5
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          color: 'primary.main',
                          fontWeight: 'bold',
                          display: 'block',
                          fontSize: '0.7rem'
                        }}
                      >
                        {note.date}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{
                          fontWeight: 'bold',
                          fontSize: isMobile ? '1rem' : '1.25rem'
                        }}
                      >
                        {note.title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        {note.description}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.primary"
                        sx={{ lineHeight: 1.7 }}
                      >
                        {note.fullDescription}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
                {index < updateNotes.length - 1 && <Divider sx={{ my: 2 }} />}
              </React.Fragment>
            ))}
          </DialogContent>
        </Dialog>
      </>
    );
  }

  // Standalone mode - Tam satır banner
  return (
    <>
      {/* Ana Banner */}
      <Box
        sx={{
          bgcolor: 'primary.main',
          color: 'white',
          py: 1.5,
          px: 2,
          cursor: 'pointer',
          position: 'relative',
          overflow: 'hidden',
          '&:hover': {
            bgcolor: 'primary.dark',
          },
          transition: 'background-color 0.3s ease'
        }}
        onClick={() => setDialogOpen(true)}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            maxWidth: '1400px',
            margin: '0 auto',
          }}
        >
          {/* Sol taraf - İkon ve Başlık */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0, flex: 1 }}>
            <CampaignIcon sx={{ fontSize: isMobile ? 20 : 24 }} />
            <Typography
              variant="body2"
              sx={{
                fontWeight: 'bold',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                whiteSpace: 'nowrap'
              }}
            >
              Güncelleme Notları:
            </Typography>
          </Box>

          {/* Orta - İçerik (Animasyonlu) */}
          <Box
            sx={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: 2
            }}
          >
            <motion.div
              key={currentNote.id}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.5 }}
              style={{ width: '100%', textAlign: 'center' }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: isMobile ? '0.75rem' : '0.875rem',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}
              >
                <strong>{currentNote.date}</strong> - {currentNote.description}
              </Typography>
            </motion.div>
          </Box>

          {/* Sağ taraf - Navigasyon ve Gösterge */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {!isMobile && (
              <>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePrev();
                  }}
                  sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                >
                  <NavigateBeforeIcon fontSize="small" />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleNext();
                  }}
                  sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' } }}
                >
                  <NavigateNextIcon fontSize="small" />
                </IconButton>
              </>
            )}
            <Typography
              variant="caption"
              sx={{
                fontSize: isMobile ? '0.65rem' : '0.75rem',
                opacity: 0.8,
                whiteSpace: 'nowrap'
              }}
            >
              {currentNoteIndex + 1}/{updateNotes.length}
            </Typography>
          </Box>
        </Box>

        {/* Progress Bar */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 2,
            bgcolor: 'rgba(255,255,255,0.3)',
          }}
        >
          <motion.div
            key={currentNoteIndex}
            initial={{ width: '0%' }}
            animate={{ width: isPaused || dialogOpen ? '0%' : '100%' }}
            transition={{ duration: 5, ease: 'linear' }}
            style={{
              height: '100%',
              backgroundColor: 'white',
            }}
          />
        </Box>
      </Box>

      {/* Tüm Güncellemeleri Gösteren Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            bgcolor: 'primary.main',
            color: 'white'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CampaignIcon />
            <Typography variant="h6">Tüm Güncelleme Notları</Typography>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setDialogOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {updateNotes.map((note, index) => (
            <React.Fragment key={note.id}>
              <Paper
                elevation={2}
                sx={{
                  p: 3,
                  mb: 2,
                  border: currentNoteIndex === index ? '2px solid' : 'none',
                  borderColor: 'primary.main',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    boxShadow: 4,
                    transform: 'translateY(-2px)'
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                  <Box
                    sx={{
                      minWidth: 60,
                      textAlign: 'center',
                      pt: 0.5
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: 'primary.main',
                        fontWeight: 'bold',
                        display: 'block',
                        fontSize: '0.7rem'
                      }}
                    >
                      {note.date}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{
                        fontWeight: 'bold',
                        fontSize: isMobile ? '1rem' : '1.25rem'
                      }}
                    >
                      {note.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1 }}
                    >
                      {note.description}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.primary"
                      sx={{ lineHeight: 1.7 }}
                    >
                      {note.fullDescription}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
              {index < updateNotes.length - 1 && <Divider sx={{ my: 2 }} />}
            </React.Fragment>
          ))}
        </DialogContent>
      </Dialog>
    </>
  );
}

export default UpdateNotesBanner;

